import { PRODUCTS_BUSINESS_ENDPOINT } from 'common/constants/endpoints'
import { request } from 'common/utils'

import { IsProductIdAvailableQuery } from '../interfaces/schemaDefinition'

import query from './isProductIdAvailable.graphql'

export const isProductIdAvailable = async (id: string): Promise<boolean> =>
  (await request<IsProductIdAvailableQuery>(PRODUCTS_BUSINESS_ENDPOINT, query, { id })).isProductIdAvailable
